"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyUserDirectory = void 0;
const domain_1 = require("@home-health-notify/domain");
/**
 * Stand-in used by UserDirectoryProvider while no organization is selected.
 *
 * Logging out calls OrganizationContext.resetData, which clears selectedOrgUser
 * before the auth guard unmounts the authenticated route group. Every list
 * still mounted then re-renders with no directory behind it. Roughly seventy
 * call sites read `userDirectory.getUserInfo(...)` straight through — the
 * context types it as IUserDirectory via a cast, so nothing ever forced them to
 * handle its absence — and the screen died with "Cannot read property
 * 'getUserInfo' of undefined" (MOBILE-APP-B4, MOBILE-APP-CQ).
 *
 * Handing back an empty directory instead of undefined keeps every one of those
 * call sites working. Rendering blank rows for the moment before the app
 * reaches the login screen is the point: the alternative — holding the subtree
 * until a directory exists — deadlocks, because the layout that calls
 * setSelectedOrgUser is itself rendered inside this provider.
 */
const placeholderUser = (id) => ({
    id,
    name: "",
    firstName: "",
    lastName: "",
    title: "",
    image: "",
    status: domain_1.USER_STATUS.ACTIVE,
    type: domain_1.USER_TYPE.USER,
    organizationId: "",
    about: "",
    groupType: domain_1.GROUP_TYPE.NON_PATIENT,
    chatType: domain_1.CHAT_TYPE.PRIVATE,
});
const emptyWorkloadCounts = {
    pendingSoc: 0,
    hospitalized: 0,
    pendingRoc: 0,
    socTotal: 0,
    socActive: 0,
    socPending: 0,
    socDischarged: 0,
};
const noop = () => undefined;
const unsubscribe = () => noop;
exports.emptyUserDirectory = {
    init: noop,
    destroy: noop,
    fetchDirectory: () => Promise.resolve({ userDirectory: (0, domain_1.CompletedResult)([]) }),
    fetchUserDirectory: () => Promise.resolve((0, domain_1.CompletedResult)([])),
    fetchAppDirectory: () => Promise.resolve(),
    getUserDirectory: () => [],
    getUserDirectoryWithoutApps: () => [],
    getActiveUserDirectory: () => [],
    getFilteredActiveUserDirectory: () => [],
    filterUserDirectory: () => [],
    searchByUserName: () => [],
    getUserInfo: (id) => placeholderUser(id),
    currentUserProfile: placeholderUser(""),
    fetchUserWorkloadDetails: () => Promise.resolve(emptyWorkloadCounts),
    registerSyncUserDirectoryListener: unsubscribe,
    updateUserListener: unsubscribe,
    registerChangeListener: unsubscribe,
    addUser: noop,
};
